<template>
  <b-modal
    @show="onShow"
    @hide="onCancel"
    body-class="md_modal_body_scroll"
    dialog-class="md_modal_dialog_full2"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
  >
    <template #modal-header="{close}">
      <div class="popup_title" style="flex: 1; text-align: center;">{{ $t('complete.toggle_site_complete') }}</div>
      <b-button class="dlg_close_btn" style="background-color: white; width:18px;" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
    </template>
    <div class="full container" style="padding: 0;">
      <div class="align-vertical" style="padding: 15px;padding-top: 0px;">
        <div class="align-vertical mt-1 center">
          <span class="caption1">{{$t('complete.sold_out_hint')}}</span>
        </div>
        <!--
        <div class="align-horizontal mt-3">
          <div class="flex_1">
            <span class="hint_desc">{{$t('complete.sold_out_hint_desc')}}</span>
          </div>
          <b-button class="btn_apply btn_apply_text" @click="onApply">
            {{$t('common.apply')}}
          </b-button>
        </div>
        -->
      </div>

      <!--      renderHouseHold Start-->
      <div class="align-vertical" style="" v-if="info.f_site_type == 'O'">
        <div class="align-horizontal v_center" style="align-items: center">
          <span class="caption">{{$t('site_detail.household_info')}}</span>
          <span class="update_time">{{ut.format($t('site_detail.update_date'), info.f_update_time ? info.f_update_time.substr(0, 10).replaceAll('-', '-') : '')}}</span>
          <b-button class="btn_apply btn_apply_text" @click="onApply" style="margin-left: auto;">
            {{$t('common.apply')}}
          </b-button>
        </div>
        <div class="align-vertical" v-for="({dong_name, floorList, hoList, saleShow, investShow, charterShow, monthlyShow}, dong_idx) in forRenderHousehold" :key="`dong-group-${dong_idx}`" style="margin-top: 10px">
          <span class="caption1" >{{dong_name}}{{$t('register.dong')}}</span>
          <div class="align-vertical" style="margin-top: 10px">
            <div class="align-horizontal" v-for="(floor, idx) in Object.keys(floorList).sort((a, b) => {return a - b})"
                 :key="`grid-floor-${idx}`" style="margin-bottom: 4px">
              <b-button
                v-for="(room, index) in floorList[floor].sort((a, b) => {
                    return a.f_ho - b.f_ho;
                  })"
                :key="`grid-room-${idx}-${index}`"
                class="grid_item align-vertical"
                :class="{ grid_item_complete: room.f_complete == 'Y' }"
                :style="{ marginLeft: index > 0 ? '4px' : '0' }"
                style="position: relative; height: 140px;justify-content: flex-start;"
                @click="onToggleComplete(room, index)"
              >
                <div class="trans_wrapper align-horizontal">
                  <div class="trans_tag"
                       :class="{'trans_trading_active': room.f_trans_type.split(',').includes('0')}">
                    {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[0] : ''}}
                  </div>
                  <div class="trans_tag"
                       :class="{'trans_charter_active': room.f_trans_type.split(',').includes('1')}">
                    {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[1] : ''}}
                  </div>
                  <div class="trans_tag"
                       :class="{'trans_month_active': room.f_trans_type.split(',').includes('3')}">
                    {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[3] : ''}}
                  </div>
                  <div class="trans_tag"
                       :class="{'trans_invest_active': room.f_trans_type.split(',').includes('2')}">
                    {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[2] : ''}}
                  </div>
                </div>
                <div class="align-horizontal v_center h_center width_100" style="height:45px;">
                  <b-img
                    :src="require('../../../assets/image/ic_photo.png')"
                    v-if="
                        room.f_image_urls.split(',').filter((it) => {
                          return it != '';
                        }).length > 0
                      "
                    style="
                        margin-right: 5px;
                        width: 20px;
                        height: 17px;
                        margin-bottom: 2px;
                      "
                  />
                  <span
                    class="grid_text"
                    :style="{
                        color: room.f_complete == 'Y' ? 'white' : 'black',
                      }"
                  >{{ room.f_ho }}</span
                  >
                </div>
                <div class="room_toilet_wrapper align-horizontal">
                  {{
                    floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ?
                      ut.format($t('site_detail.room_toilet_num'), room.f_room, room.f_toilet) :
                      ut.format($t('site_detail.room_toilet_num_short'), room.f_room, room.f_toilet)
                  }}
                </div>
                <div class="dup_teras_wrapper align-horizontal">
                  <div class="trans_tag" :class="{'dup_teras_active': room.f_duplex == 'Y'}">
                    {{floorList[floor].length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                    $t('room_info_popup.duplex') : $t('room_info_popup.duplex_short')}}
                  </div>
                  <div class="trans_tag" :class="{'dup_teras_active': room.f_teras == 'Y'}">
                    {{floorList[floor].length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                    $t('site_detail.teras') : $t('site_detail.teras_short')}}
                  </div>
                </div>
                <div class="complete_mask" v-if="room.f_complete == 'Y'">
                  {{$t("site_detail.done")}}
                </div>
              </b-button>
            </div>
          </div>

          <div class="align-vertical table" style="margin-top: 5px; margin-bottom: 10px">
            <div class="align-horizontal thead">
              <div class="th blind" style="width: 50px">
                <span class="cell_text_bold">{{ $t("register.ho") }}</span>
              </div>
              <div class="th blind" style="flex: 0.5">
                <span class="cell_text_bold">{{ $t("register.room") }}</span>
              </div>
              <div class="th blind" style="flex: 0.5">
                  <span class="cell_text_bold">{{
                      $t("site_detail.toilet1")
                    }}</span>
              </div>
              <div class="th blind trans_trading_active" v-if="saleShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("register.parcel_out")
                    }}</span>
              </div>
              <div class="th blind trans_trading_active"
                   v-if="saleShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("site_detail.collateral_short")
                    }}</span>
              </div>
              <div class="th blind trans_charter_active" v-if="charterShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.charter")
                    }}</span>
              </div>
              <div class="th blind trans_month_active" v-if="monthlyShow" style="flex: 1.8">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.monthly")
                    }}</span>
              </div>
              <div class="th blind trans_invest_active" v-if="investShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.invest")
                    }}</span>
              </div>
              <div class="th blind" style="flex: 1">
                  <span class="cell_text_bold">{{
                      $t("site_detail.private")
                    }}</span>
              </div>
              <div class="th blind" style="flex: 1" v-if="info.f_site_type == 'G'">
                  <span class="cell_text_bold">{{
                      $t("site_detail.real_size")
                    }}</span>
              </div>
              <div class="th blind" style="flex: 1">
                  <span class="cell_text_bold">{{
                      $t("site_detail.dup_teras")
                    }}</span>
              </div>
            </div>
            <div class="align-vertical tbody">
              <div
                v-for="(room, index) in hoList
                    .sort((a, b) => {
                      if (a.f_floor != b.f_floor) {
                        return a.f_floor - b.f_floor;
                      } else {
                        return a.f_ho - b.f_ho;
                      }
                    })
                    .filter((it) => {
                      return it.f_complete == 'N';
                    })"
                :key="`house-${index}`"
              >
                <div
                  class="align-horizontal row_container"
                  v-if="room.f_memo == ''"
                >
                  <div class="th blind" style="width: 50px;">
                    <span class="cell_text">{{ renderText(room.f_ho) }}</span>
                  </div>
                  <div class="th blind" style="flex: 0.5">
                      <span class="cell_text">{{
                          renderText(room.f_room)
                        }}</span>
                  </div>
                  <div class="th blind" style="flex: 0.5">
                      <span class="cell_text">{{
                          renderText(room.f_toilet)
                        }}</span>
                  </div>
                  <div v-if="saleShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('0') ? room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_sale_price)) : "-"
                        }}</span>
                  </div>
                  <div v-if="saleShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('0') ? room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_collateral_price == null ? '' : room.f_collateral_price)) : "-"
                        }}</span>
                  </div>
                  <div v-if="charterShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('1') ? room.f_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_charter_price)) : "-"
                        }}</span>
                  </div>
                  <div v-if="monthlyShow" class="th blind" style="flex: 1.8">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('3') ? room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(
                              [
                                u.currency(
                                  room.f_monthly_rent_deposit
                                    ? room.f_monthly_rent_deposit
                                    : ""
                                ),
                                u.currency(
                                  room.f_monthly_rent ? room.f_monthly_rent : ""
                                ),
                              ]
                                .filter((it) => {
                                  return it != "" && it != "0";
                                })
                                .join("/")
                            ) : "-"
                        }}</span>
                  </div>
                  <div v-if="investShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('2') ? room.f_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_investment_price)) : "-"
                        }}</span>
                  </div>
                  <div class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          renderText(room.f_exclusive_size)
                        }}</span>
                  </div>
                  <div class="th blind" style="flex: 1" v-if="false">
                      <span class="cell_text">{{
                          renderText(room.f_real_size)
                        }}</span>
                  </div>
                  <div class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          renderDupTerasText(room.f_duplex, room.f_teras)
                        }}</span>
                  </div>
                </div>
                <div class="align-horizontal" style="width: 100%" v-else>
                  <div
                    class="th_double"
                    style="
                        width: 50px;
                        display: flex;
                        border-left: solid 1px #d0d0d0;
                      "
                  >
                      <span class="item_label">{{
                          renderText(room.f_ho)
                        }}</span>
                  </div>
                  <div
                    class="th_double flex_1"
                    style="width: calc(100% - 50px)"
                  >
                    <div
                      class="align-horizontal th3 flex_1"
                      style="border-top-width: 0"
                    >
                      <div class="th2 blind" style="flex: 0.5;">
                          <span class="cell_text">{{
                              renderText(room.f_room)
                            }}</span>
                      </div>
                      <div class="th2 blind" style="flex: 0.5">
                          <span class="cell_text">{{
                              renderText(room.f_toilet)
                            }}</span>
                      </div>
                      <div v-if="saleShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              room.f_trans_type.split(',').includes('0') ? room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(room.f_sale_price)) : "-"
                            }}</span>
                      </div>
                      <div v-if="saleShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              room.f_trans_type.split(',').includes('0') ? room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(room.f_collateral_price == null ? '' : room.f_collateral_price)) : "-"
                            }}</span>
                      </div>
                      <div v-if="charterShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              room.f_trans_type.split(',').includes('1') ? room.f_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(room.f_charter_price)) : "-"
                            }}</span>
                      </div>
                      <div v-if="monthlyShow" class="th2 blind" style="flex: 1.8">
                          <span class="cell_text">{{
                              room.f_trans_type.split(',').includes('3') ? room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(
                                [
                                  u.currency(
                                    room.f_monthly_rent_deposit
                                      ? room.f_monthly_rent_deposit
                                      : ""
                                  ),
                                  u.currency(
                                    room.f_monthly_rent ? room.f_monthly_rent : ""
                                  ),
                                ]
                                  .filter((it) => {
                                    return it != "" && it != "0";
                                  })
                                  .join("/")
                              ) : "-"
                            }}</span>
                      </div>
                      <div v-if="investShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              room.f_trans_type.split(',').includes('2') ? room.f_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                              renderText(u.currency(room.f_investment_price)) : "-"
                            }}</span>
                      </div>
                      <div class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              renderText(room.f_exclusive_size)
                            }}</span>
                      </div>
                      <div class="th2 blind" style="flex: 1" v-if="false">
                          <span class="cell_text">{{
                              renderText(room.f_real_size)
                            }}</span>
                      </div>
                      <div class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              renderDupTerasText(room.f_duplex, room.f_teras)
                            }}</span>
                      </div>
                    </div>
                    <div class="flex_1">
                      <div
                        class="th flex_1"
                        style="display: flex; align-items: center"
                      >
                          <span
                            class="cell_text line-one"
                            style="text-align: left; padding-left: 10px"
                          >{{ replaceEnter(room.f_memo) }}</span
                          >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      renderHouseHold End-->
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
const utils = require('util');
export default {
  name: "SetSaleCompletePopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    site_idx: {},
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
      info: {},
      hoList: [],
      dongList: [],
      roomInfo: {},
      showLoading: false
    }
  },
  mounted() {

  },
  inject: ['eventBus'],
  computed: {
    forRenderHousehold() {
      const { info, dongList, hoList } = this;

      let list = [];
      dongList.forEach(dong => {
        let floorList = {};
        hoList
          .filter(ho => {
            return ho.f_dong_idx == dong.f_idx
          })
          .forEach(it => {
            if (!floorList.hasOwnProperty(it.f_floor)) {
              floorList[it.f_floor] = [];
            }
            floorList[it.f_floor].push(it);
          });

        let ho_list = hoList.filter(ho => {
          return ho.f_dong_idx == dong.f_idx
        })

        let saleShow = ho_list.some(it => {
          return it.f_trans_type.split(',').includes('0') && it.f_complete != 'Y'
        });
        // saleShow = saleShow && info.f_transaction_type.includes('0');

        let charterShow = ho_list.some(it => {
          return it.f_trans_type.split(',').includes('1') && it.f_complete != 'Y'
        });
        // charterShow = charterShow && info.f_transaction_type.includes('1');

        let investShow = ho_list.some(it => {
          return it.f_trans_type.split(',').includes('2') && it.f_complete != 'Y'
        });
        // investShow = investShow && info.f_transaction_type.includes('2');

        let monthlyShow = ho_list.some(it => {
          return it.f_trans_type.split(',').includes('3') && it.f_complete != 'Y'
        });
        // monthlyShow = monthlyShow && info.f_transaction_type.includes('3');

        list.push({
          dong_id: dong.f_idx,
          dong_name: dong.f_dong,
          hoList: ho_list,
          floorList: floorList,
          saleShow: saleShow,
          charterShow: charterShow,
          investShow: investShow,
          monthlyShow: monthlyShow
        });
      });
      return list
    },
  },
  methods:{
    onToggleComplete(room, index) {
      Utils.setState(this,{
        hoList: this.hoList.map(it => {
          if (it.f_idx == room.f_idx) {
            it.f_complete = it.f_complete == 'Y' ? 'N' : 'Y';
          }
          return it;
        })
      });
    },
    renderText (text) {
      return text == '' || text == '0' ? '-' : text;
    },

    replaceEnter (text)  {
      return text.replace(/\n/g, " ");
    },

    renderDupTerasText(isDup, isTeras) {
      let resultText = "-";
      if (isDup == 'Y' && isTeras == 'Y') {
        resultText = this.info.f_site_type == 'O' ? this.$t('site_detail.dup_teras') : this.$t('site_detail.dup_teras1');
      } else if (isDup == 'Y') {
        resultText = this.info.f_site_type == 'O' ?  this.$t('room_info_popup.duplex_short') :  this.$t('room_info_popup.duplex');
      } else if (isTeras == 'Y') {
        resultText = this.info.f_site_type == 'O' ?  this.$t('site_detail.teras_short') :  this.$t('site_detail.teras');
      }

      return resultText;
    },

    getTransText (defaultText, room) {
      let roomTransTypeList = room.f_trans_type.split(',').filter(it => {
        return it != '' && it != '3'
      });

      if (roomTransTypeList.length == 2 && (room.f_trans_type.includes('0,2') || room.f_trans_type.includes('2,0'))) {
        return this.$t('interest.trading1');
      }

      return roomTransTypeList.length > 1 ? this.$t('dongsi') : defaultText;
    },
    onShow() {
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null,);
      Utils.setState(this,{ showLoading: true });
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: this.site_idx,
        },
      ).then(result => {
        Utils.setState(this,{ showLoading: false });
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this,{
            info: result.data.common,
            contactList: result.data.contact_list,
            dongList: result.data.dong_list,
            hoList: result.data.ho_list
              .map(it => {
                it.f_room = it.f_room == 0 ? 1 : (it.f_room == 1 ? 1.5 : it.f_room);
                return it;
              })
              .sort((a, b) => a.f_ho - b.f_ho),
          });
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },
    onApply() {
      let { hoList } = this;

      Utils.setState(this,{ showLoading: true });
      Utils.requestPost(
        this.$c.API.Site.setCompleteHouse,
        {
          site_idx: this.info.f_idx,
          ho_idx_list: hoList.filter(it => {
            return it.f_complete == 'Y'
          }).map(it => {
            return it.f_idx
          }).join(','),
        }).then(result => {
        Utils.setState(this,{ showLoading: false });
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('common.save_success'));
          this.eventBus.$emit('sale_complete');
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },
    onCancel()  {
      if (this.visible) {
        Utils.setState(this, {
          info: {},
          hoList: [],
          dongList: [],
          roomInfo: {},
          showLoading: false
        });
        if(window.history.state == "forward")
          window.history.back();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
@import "../../../assets/css/main/interest/SiteDetail";
.hint_desc { color: #666666; font-size: $fs_18; font-family: $korean_gd_14_r; line-height: 17px }
.caption1 { color: $text; font-size: $fs_18; font-family: $korean_gd_15_r; }
.btn_apply {
  width: 70px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  //border-radius: 3px;
}
.btn_apply_text { color: $white; font-size: $fs_14; font-family: $korean_gd_14_r }


</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SetSaleCompletePopup.vue